/* eslint-disable @typescript-eslint/no-explicit-any */
import { GamoraErrorAssertion } from '../errors/index.js';
import { GamoraFoundationErrorConstructorType } from '../foundation/error/error.js';

/**
 * Global configuration
 */
export interface GamoraUtilsAssertGlobalConfiguration {
  trace: boolean;
}

/**
 * Assert
 * @param assertion   Any boolean expression
 * @param message     [optional] A assertion message
 * @param GamoraError [optional] A GamoraError constructor
 */
export function assert(
  assertion: any,
  message?: string,
  ctor?: GamoraFoundationErrorConstructorType,
): asserts assertion {
  // Test assertion
  if (!assertion) {
    // Create a trace
    if (assert.configuration.trace) {
      console.trace();
    }

    // Throw statement
    if (ctor) {
      assert(
        ctor?.prototype instanceof Error,
        'Invalid ctor argument: not a valid Error.',
      );

      // Throw the GamoraFoundationError
      throw new ctor(message);
    } else {
      throw new GamoraErrorAssertion(message);
    }
  }
}

/**
 * Assert global configuration
 */
assert.configuration = {
  trace: false,
} as GamoraUtilsAssertGlobalConfiguration;
